import React, { useState } from "react";
import "./ProfileComponent.css";
import { socialProfiles } from "../../constants/socialIDs";

const profiles = [
  "Coding Profile",
  "Research Profile",
  "Social Profile",
  "Other Portfolio",
];

const ProfileComponent = () => {
  const [activeProfile, setActiveProfile] = useState(0);

  const switchProfile = (direction) => {
    if (direction === "prev") {
      setActiveProfile((prev) => (prev === 0 ? profiles.length - 1 : prev - 1));
    } else {
      setActiveProfile((prev) => (prev === profiles.length - 1 ? 0 : prev + 1));
    }
  };

  const renderProfileItems = (profileItems) => {
    return profileItems.map((item, index) => (
      <div className="profile-item" key={index}>
        <a href={item.url} target="blank">
          <img src={item.imgSrc} alt={item.name} height="30" width="30" />
        </a>
        <h3>{item.name}</h3>
        <p>{item.username}</p>
      </div>
    ));
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <button onClick={() => switchProfile("prev")} className="profile-arrow">
          <svg
            fill="var(--raw-seinna)"
            height="24px"
            width="24px"
            viewBox="0 0 55.753 55.753"
          >
            <path d="M12.745,23.915c0.283-0.282,0.59-0.52,0.913-0.727L35.266,1.581c2.108-2.107,5.528-2.108,7.637,0.001 c2.109,2.108,2.109,5.527,0,7.637L24.294,27.828l18.705,18.706c2.109,2.108,2.109,5.526,0,7.637 c-1.055,1.056-2.438,1.582-3.818,1.582s-2.764-0.526-3.818-1.582L13.658,32.464c-0.323-0.207-0.632-0.445-0.913-0.727 c-1.078-1.078-1.598-2.498-1.572-3.911C11.147,26.413,11.667,24.994,12.745,23.915z"></path>
          </svg>
        </button>
        <h2 className="profile-title">{profiles[activeProfile]}</h2>
        <button onClick={() => switchProfile("next")} className="profile-arrow">
          <svg
            fill="var(--raw-seinna)"
            height="24px"
            width="24px"
            viewBox="0 0 55.752 55.752"
          >
            <path d="M43.006,23.916c-0.28-0.282-0.59-0.52-0.912-0.727L20.485,1.581c-2.109-2.107-5.527-2.108-7.637,0.001 c-2.109,2.108-2.109,5.527,0,7.637l18.611,18.609L12.754,46.535c-2.11,2.107-2.11,5.527,0,7.637c1.055,1.053,2.436,1.58,3.817,1.58 s2.765-0.527,3.817-1.582l21.706-21.703c0.322-0.207,0.631-0.444,0.912-0.727c1.08-1.08,1.598-2.498,1.574-3.912 C44.605,26.413,44.086,24.993,43.006,23.916z"></path>
          </svg>
        </button>
      </div>
      <div className="profile-body">
        {activeProfile === 0 && (
          <div className="profile-content">
            <img
              src="https://cdni.iconscout.com/illustration/premium/thumb/react-native-programmer-7464458-6109661.png?f=webp"
              alt="Coding"
              className="profile-icon"
            />
            <div className="profile-details">
              <div className="profile-grid">
                {renderProfileItems(socialProfiles.codingProfile)}
              </div>
            </div>
          </div>
        )}
        {activeProfile === 1 && (
          <div className="profile-content">
            <img
              src="https://png.pngtree.com/png-clipart/20230914/original/pngtree-research-paper-vector-png-image_12149606.png"
              alt="Research"
              className="profile-icon"
            />
            <div className="profile-details">
              <div className="profile-grid">
                {renderProfileItems(socialProfiles.researchProfile)}
              </div>
            </div>
          </div>
        )}
        {activeProfile === 2 && (
          <div className="profile-content">
            <img
              src="https://cdni.iconscout.com/illustration/premium/thumb/social-profile-9765564-7947782.png?f=webp"
              alt="Social"
              className="profile-icon"
            />
            <div className="profile-details">
              <div className="profile-grid">
                {renderProfileItems(socialProfiles.socialProfile)}
              </div>
            </div>
          </div>
        )}
        {activeProfile === 3 && (
          <div className="profile-content">
            <img
              src="https://cdni.iconscout.com/illustration/premium/thumb/portfolio-profile-document-10353628-8341299.png?f=webp"
              alt="Other"
              className="profile-icon"
            />
            <div className="profile-details">
              <div className="profile-grid">
                {renderProfileItems(socialProfiles.otherProfile)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileComponent;
